import { AppointmentDate, AppointmentTypes, typeAppointmentSartoria, Optional } from "./Models/Types.ts";

 const DEFAULT_BASE_URL = "https://api.temptation.it"; 
//const DEFAULT_BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://192.168.0.211:7014" : "https://api.temptation.it";

export type FetchAppointmentResponse = {
  date_next_request: string,
  dates: Array<AppointmentDate>
}

const fetchAppointments = async (type: AppointmentTypes, men: number, women : number, startDate?: string): Promise<FetchAppointmentResponse> => {
  const url = `${DEFAULT_BASE_URL}/calendario?tipo=${type}&uomini=${men}&donne=${women}${startDate ? `&data_inizio=${startDate}` : ''
    }`;

  const response = await fetch(url);

  if (!response.ok) {
    console.log(response)
    throw new Error(`Errore API: ${response.status}`);
  }

  const responseJson = await response.json();

  let returnData: FetchAppointmentResponse = {
    date_next_request: responseJson.data.date_next_request,
    dates: responseJson.data.dates
  };
  return returnData;
};

export type AppointmentRequestBase = {
  name: string,
  surname: string,
  email: string,
  phone: string,
  locality: string,
  note: string,
  date: string,
  event_date: string,
  times: {
    start: string,
    end: string
  },
  type: AppointmentTypes,
  manNumber: number,
  womanNumber: number,
  tailoringData: {
    mainId: number,
    confirmedIds: Array<number>
  }
  [key: string | symbol]: string | number | AppointmentTypes | Object
}

export namespace AppointmentRequestBase {
  export function getEmptyRequest(): AppointmentRequestBase {
    return {
      date: "",
      email: "",
      event_date: "",
      locality: "",
      name: "",
      note: "",
      phone: "",
      surname: "",
      manNumber: 0,
      womanNumber: 0,
      times: {
        end: "",
        start: ""
      },
      type: AppointmentTypes.NONE,
      tailoringData : {
        confirmedIds : [],
        mainId : 0
      }
    }
  }
}



export type AppointmentSartoriaRequest = {
  telephone: string
}
export type AppointmentRequest = Optional<AppointmentRequestBase, "tailoringData">;

export namespace AppointmentRequest {
  export function getEmptyRequest(): AppointmentRequest {
    let returnValue: AppointmentRequest = {
      date: "",
      email: "",
      event_date: "",
      locality: "",
      name: "",
      note: "",
      phone: "",
      surname: "",
      manNumber: 0,
      womanNumber: 0,
      times: {
        end: "",
        start: ""
      },
      type: AppointmentTypes.NONE
    }

    return returnValue;
  }
}

const createAppointment = async (dataIn: AppointmentRequest): Promise<boolean> => {

  const data = dataIn as AppointmentRequestBase;
  // modifica del 04 febbraio 2025, se è sposo o sposa questi 2 parametri vanno a 0 sennò tacoatelier li visualizza in maniera errata.
  if(data.type === AppointmentTypes.BRIDE || data.type === AppointmentTypes.GROOM){
    data.manNumber = 0;
    data.womanNumber = 0;
  }

  const response = await fetch(`${DEFAULT_BASE_URL}/appuntamenti`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (response.status !== 200) {
    let result = await response.json();
    throw new Error(`Errore API: ${result.result.description}`);
  }

  return response.status === 200;
};

export type FetchAppointmentSartoriaResponse = {
  data: typeAppointmentSartoria
}

export namespace AppointmentSartoriaRequest {
  export function getEmptyRequest(): AppointmentSartoriaRequest {
    let returnValue = {
      telephone: ""
    }
    return returnValue
  }
}

const getAppointmentSartoria = async (data: AppointmentSartoriaRequest): Promise<FetchAppointmentSartoriaResponse> => {
  const response = await fetch(`${DEFAULT_BASE_URL}/calendario/sartoria`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (response.status !== 200) {
    let result = await response.json();
    throw new Error(`Errore API: ${result.result.description}`);
  }

  const responseJson = await response.json();

  let returnData: FetchAppointmentSartoriaResponse = {
    data: responseJson.data
  };
  return returnData;
};


export const RemoteAPI = {
  fetchAppointments,
  createAppointment,
  getAppointmentSartoria
}